<template>
    <div class="
      sticky bottom-0 flex h-[65px] min-h-[65px] w-full text-[14px]

      lg:h-[113px] lg:text-[16px]
    "
        :class="{ 'hidden': false && isKeyboardOpen }"
    >
        <price-info class="flex size-full flex-1" />
        <button
            class="
              h-full w-1/2 bg-olive font-caption text-white outline-none transition-[outline] duration-200 focus-outline-only-inside-white focus-outline-only

              lg:w-[264px]
            "
            @click="review"
        >
            {{ $t('REVIEW') }}
        </button>
    </div>
</template>

<script>
    import PriceInfo from './PriceInfo.vue';
    import allStores from '../stores/all';

    import {
        STEP_REVIEW,
    } from '../constants';

    import { isPersonalizationFilled } from '../helpers/components';

    export default {
        mixins: [allStores],

        components: {
            PriceInfo,
        },

        computed: {
            isKeyboardOpen() {
                return this.appStore.isKeyboardOpen;
            },

            viewController() {
                return this.customizerStore.viewController;
            },

            groupPersonalization() {
                return this.customizerStore.groupPersonalization;
            },
        },

        methods: {
            isDirty() {
                for (const state of this.viewController.state) {
                    if (isPersonalizationFilled(state.component)) {
                        return true;
                    }
                }

                return false;
            },

            review() {
                let groupErrors = false;

                if (this.groupPersonalization) {
                    for (const item of this.groupPersonalization) {
                        if (!item.valid) {
                            groupErrors = true;
                        }
                    }
                }

                if (groupErrors) {
                    this.customizerStore.toggleReviewGroupTextModal();
                    return;
                }

                if (!this.isDirty()) {
                    this.customizerStore.toggleReviewConfirmationModal();
                    return;
                }

                this.appStore.setCurrentStep(STEP_REVIEW);
            },
        },
    };
</script>
